/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Comparison_CurrentInputs */

const id_components_comparison_current = /** @type {(inputs: Components_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saat Ini`)
};

const ms_components_comparison_current = /** @type {(inputs: Components_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semasa`)
};

const da_components_comparison_current = /** @type {(inputs: Components_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuværende`)
};

const de_components_comparison_current = /** @type {(inputs: Components_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuell`)
};

const en_us2_components_comparison_current = /** @type {(inputs: Components_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current`)
};

const es_es2_components_comparison_current = /** @type {(inputs: Components_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actual`)
};

const es_mx2_components_comparison_current = /** @type {(inputs: Components_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actual`)
};

const fil_components_comparison_current = /** @type {(inputs: Components_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kasalukuyan`)
};

const fr_components_comparison_current = /** @type {(inputs: Components_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actuel`)
};

const it_components_comparison_current = /** @type {(inputs: Components_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corrente`)
};

const hu_components_comparison_current = /** @type {(inputs: Components_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuális`)
};

const nl_components_comparison_current = /** @type {(inputs: Components_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huidig`)
};

const no_components_comparison_current = /** @type {(inputs: Components_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nåværende`)
};

const pl_components_comparison_current = /** @type {(inputs: Components_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obecna`)
};

const pt_br2_components_comparison_current = /** @type {(inputs: Components_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current`)
};

const pt_components_comparison_current = /** @type {(inputs: Components_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atual`)
};

const ro_components_comparison_current = /** @type {(inputs: Components_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actual`)
};

const fi_components_comparison_current = /** @type {(inputs: Components_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nykyinen`)
};

const sv_components_comparison_current = /** @type {(inputs: Components_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuvarande`)
};

const vi_components_comparison_current = /** @type {(inputs: Components_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiện tại`)
};

const tr_components_comparison_current = /** @type {(inputs: Components_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Güncel`)
};

const cs_components_comparison_current = /** @type {(inputs: Components_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuální`)
};

const bg_components_comparison_current = /** @type {(inputs: Components_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текуща`)
};

const ru_components_comparison_current = /** @type {(inputs: Components_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текущая`)
};

const uk_components_comparison_current = /** @type {(inputs: Components_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поточна`)
};

const ar_components_comparison_current = /** @type {(inputs: Components_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحالي`)
};

const hi_components_comparison_current = /** @type {(inputs: Components_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तमान`)
};

const th_components_comparison_current = /** @type {(inputs: Components_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปัจจุบัน`)
};

const ja_components_comparison_current = /** @type {(inputs: Components_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在`)
};

const zh_cn2_components_comparison_current = /** @type {(inputs: Components_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current`)
};

const zh_hant1_components_comparison_current = /** @type {(inputs: Components_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current`)
};

const ko_components_comparison_current = /** @type {(inputs: Components_Comparison_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current`)
};

/**
* | output |
* | --- |
* | "Current" |
*
* @param {Components_Comparison_CurrentInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_comparison_current = /** @type {((inputs?: Components_Comparison_CurrentInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Comparison_CurrentInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_comparison_current(inputs)
	if (locale === "ms") return ms_components_comparison_current(inputs)
	if (locale === "da") return da_components_comparison_current(inputs)
	if (locale === "de") return de_components_comparison_current(inputs)
	if (locale === "en-US") return en_us2_components_comparison_current(inputs)
	if (locale === "es-ES") return es_es2_components_comparison_current(inputs)
	if (locale === "es-MX") return es_mx2_components_comparison_current(inputs)
	if (locale === "fil") return fil_components_comparison_current(inputs)
	if (locale === "fr") return fr_components_comparison_current(inputs)
	if (locale === "it") return it_components_comparison_current(inputs)
	if (locale === "hu") return hu_components_comparison_current(inputs)
	if (locale === "nl") return nl_components_comparison_current(inputs)
	if (locale === "no") return no_components_comparison_current(inputs)
	if (locale === "pl") return pl_components_comparison_current(inputs)
	if (locale === "pt-BR") return pt_br2_components_comparison_current(inputs)
	if (locale === "pt") return pt_components_comparison_current(inputs)
	if (locale === "ro") return ro_components_comparison_current(inputs)
	if (locale === "fi") return fi_components_comparison_current(inputs)
	if (locale === "sv") return sv_components_comparison_current(inputs)
	if (locale === "vi") return vi_components_comparison_current(inputs)
	if (locale === "tr") return tr_components_comparison_current(inputs)
	if (locale === "cs") return cs_components_comparison_current(inputs)
	if (locale === "bg") return bg_components_comparison_current(inputs)
	if (locale === "ru") return ru_components_comparison_current(inputs)
	if (locale === "uk") return uk_components_comparison_current(inputs)
	if (locale === "ar") return ar_components_comparison_current(inputs)
	if (locale === "hi") return hi_components_comparison_current(inputs)
	if (locale === "th") return th_components_comparison_current(inputs)
	if (locale === "ja") return ja_components_comparison_current(inputs)
	if (locale === "zh-CN") return zh_cn2_components_comparison_current(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_comparison_current(inputs)
	return ko_components_comparison_current(inputs)
});
export { components_comparison_current as "components.comparison.current" }